import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { IconButton } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../Store";
import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";
import { useFormikContext } from "formik";

interface Props {
  children?: React.ReactNode;
  [otherProps: string]: any;
}
const AppSendSubmitButton: React.FC<Props> = ({ ...otherProps }) => {
  const { typingStatus } = useAppSelector(allMessagesStore);

  // const { isValid } = useFormikContext<any>();
  return (
    <div className="inputActionBox">
      <IconButton
        type="submit"
        {...otherProps}
        disabled={!typingStatus ? false : true}
      >
        {!typingStatus ? (
          <SendRoundedIcon 
          // style={isValid ? {} : { color: "#7E8392" }}
           />
        ) : (
          <MoreHorizIcon style={{ color: `#7E8392` }} />
        )}
      </IconButton>
    </div>
  );
};

export default AppSendSubmitButton;
